// extracted by mini-css-extract-plugin
export var formContainer = "_ml-0";
export var message = "_ml-1";